module.exports = __webpack_public_path__ + "img/help.407a2e52.svg";